"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Badge = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _designTokensReact = require("@smartsheet/design-tokens-react");
const badgeTheme = {
  borderColor: {
    canvas: (0, _designTokensReact.color)("color--background--surfaces--canvas"),
    "work-surface": (0, _designTokensReact.color)("color--background--surfaces--work", _designTokens.ursaColors.neutral00)
  }
};

// This component is not meant to be shipped to consumers.
const Badge = (0, _styled.default)("span")`
    ${_ref => {
  let {
    backgroundColor,
    size,
    color,
    renderOn
  } = _ref;
  return `
        box-sizing: content-box;
        border-width: 1px;
        border-style: solid;
        border-color: ${badgeTheme.borderColor[renderOn]};
        background-color: ${backgroundColor};
        height: ${size}px;
        color: ${color};
        font-size: 8px;
        font-weight: 700;
        font-family: inherit;
        line-height: 8px;
        letter-spacing: -0.2px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: absolute;
        transition: all ${_designTokens.motion.animation.default};
    `;
}}
`;
exports.Badge = Badge;
//# sourceMappingURL=Badge.js.map